(function secureSr1Gate(window, document) {
  'use strict';

  // Lock Sales Rep-only surfaces immediately. The verified session removes this
  // class after authorization; customers never rely on cart attributes alone.
  document.documentElement.classList.add('cap-sr1-locked');

  var config = window.__CAP_SR1_CONFIG__ || {};
  var supabaseUrl = String(config.supabaseUrl || '').replace(/\/$/, '');
  var publishableKey = String(config.publishableKey || '');
  var nativeFetch = window.fetch.bind(window);
  var sessionKey = 'cap_sr1_auth_session_v1';
  var state = {
    phase: 'checking',
    session: null,
    rep: null,
    freshUntil: 0,
    timer: 0,
    authPromise: null
  };

  var repRpcMap = {
    rpc_storefront_rep_identifier_lookup_v1: 'rpc_storefront_rep_identifier_lookup_v3',
    rpc_storefront_rep_identifier_lookup_v2: 'rpc_storefront_rep_identifier_lookup_v3',
    rpc_storefront_lookup_vins: 'rpc_storefront_lookup_vins_sr1_v1',
    rpc_storefront_rep_identifier_search_v1: 'rpc_storefront_rep_identifier_search_v3',
    rpc_storefront_rep_identifier_search_v2: 'rpc_storefront_rep_identifier_search_v3',
    rpc_storefront_rep_product_lookup_v1: 'rpc_storefront_rep_product_lookup_v3',
    rpc_storefront_rep_product_lookup_v2: 'rpc_storefront_rep_product_lookup_v3',
    rpc_storefront_rep_identifier_lookup_v3: 'rpc_storefront_rep_identifier_lookup_v3',
    rpc_storefront_rep_advanced_identifier_search_v1: 'rpc_storefront_rep_advanced_identifier_search_v1',
    rpc_storefront_rep_donor_parts_v1: 'rpc_storefront_rep_donor_parts_v1'
  };

  var dualRpcMap = {
    rpc_storefront_search_multi_parts_vehicles_v1: {
      public: 'rpc_storefront_search_multi_parts_vehicles_public_v2',
      rep: 'rpc_storefront_search_multi_parts_vehicles_sr1_v1'
    },
    rpc_storefront_search_page_v2: {
      public: 'rpc_storefront_search_page_public_v3',
      rep: 'rpc_storefront_search_page_sr1_v1'
    },
    rpc_storefront_search_page_v9: {
      public: 'rpc_storefront_search_page_v9',
      rep: 'rpc_storefront_search_page_sr1_v2'
    },
    rpc_storefront_search_page_v10: {
      public: 'rpc_storefront_search_page_v10',
      rep: 'rpc_storefront_search_page_sr1_v3'
    },
    rpc_storefront_search_parts_with_media_v1: {
      public: 'rpc_storefront_search_parts_with_media_public_v2',
      rep: 'rpc_storefront_search_parts_with_media_sr1_v1'
    },
    rpc_storefront_open_search_parts_with_media_v1: {
      public: 'rpc_storefront_open_search_parts_with_media_public_v2',
      rep: 'rpc_storefront_open_search_parts_with_media_sr1_v1'
    },
    rpc_storefront_search_donor_parts_with_media_v1: {
      public: 'rpc_storefront_search_donor_parts_with_media_public_v3',
      rep: 'rpc_storefront_search_donor_parts_with_media_sr1_v1'
    },
    rpc_storefront_search_vehicles_v1: {
      public: 'rpc_storefront_search_vehicles_public_v2',
      rep: 'rpc_storefront_search_vehicles_sr1_v1'
    },
    rpc_storefront_search_vehicles_with_media_v1: {
      public: 'rpc_storefront_search_vehicles_public_v2',
      rep: 'rpc_storefront_search_vehicles_sr1_v1'
    },
    rpc_storefront_open_search_vehicles_v1: {
      public: 'rpc_storefront_open_search_vehicles_public_v2',
      rep: 'rpc_storefront_open_search_vehicles_sr1_v1'
    }
  };

  var sensitiveReadModels = new Set([
    'storefront_rep_identifier_read_v1',
    'storefront_fitment_index',
    'storefront_inventory_fitment_with_media_v1',
    'v_vehicle_identity_facts_for_monday'
  ]);

  function installVisibilityGuard() {
    if (document.getElementById('cap-sr1-visibility-guard')) return;
    var style = document.createElement('style');
    style.id = 'cap-sr1-visibility-guard';
    style.textContent = [
      'html.cap-sr1-locked .cart-rep-fields,',
      'html.cap-sr1-locked .rep-tools,',
      'html.cap-sr1-locked [data-cap-sr1-advanced] { display: none !important; }',
      'html.cap-sr1-locked cart-items.is-empty.is-rep .cart__warnings { display: block !important; }',
      'html.cap-sr1-locked cart-items.is-empty.is-rep .cart__contents { display: none !important; }',
      'select[data-sr1-identity-locked="true"] { opacity: 1 !important; cursor: not-allowed !important; }'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }

  installVisibilityGuard();

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function safeJson(response) {
    return response.json().catch(function () { return {}; });
  }

  function emit() {
    document.documentElement.classList.toggle('cap-sr1-authorized', state.phase === 'authorized');
    document.documentElement.classList.toggle('cap-sr1-locked', state.phase !== 'authorized');
    if (state.phase === 'authorized') enforceVerifiedRepFields();
    else unlockVerifiedRepFields();
    document.dispatchEvent(new CustomEvent('cap:sr1-state', { detail: getPublicState() }));
  }

  function getPublicState() {
    return {
      phase: state.phase,
      authorized: state.phase === 'authorized' && state.freshUntil > Date.now(),
      rep: state.rep ? Object.assign({}, state.rep) : null,
      freshUntil: state.freshUntil || 0
    };
  }

  function loadSession() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(sessionKey) || 'null');
      if (!parsed || !parsed.access_token || !parsed.refresh_token) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function saveSession(session) {
    state.session = session || null;
    if (!session) {
      window.sessionStorage.removeItem(sessionKey);
      return;
    }
    window.sessionStorage.setItem(sessionKey, JSON.stringify(session));
  }

  function sessionExpiryMs(session) {
    if (!session) return 0;
    if (Number(session.expires_at)) return Number(session.expires_at) * 1000;
    if (Number(session.expires_in)) return Date.now() + Number(session.expires_in) * 1000;
    return 0;
  }

  async function refreshAuthToken() {
    var session = state.session;
    if (!session || !session.refresh_token) throw new Error('Your secure session has expired.');
    var response = await nativeFetch(supabaseUrl + '/auth/v1/token?grant_type=refresh_token', {
      method: 'POST',
      headers: {
        apikey: publishableKey,
        Authorization: 'Bearer ' + publishableKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ refresh_token: session.refresh_token })
    });
    var payload = await safeJson(response);
    if (!response.ok || !payload.access_token) throw new Error('Your secure session has expired.');
    saveSession(payload);
    return payload;
  }

  async function ensureLiveToken() {
    if (!state.session) state.session = loadSession();
    if (!state.session) throw new Error('Secure sign-in is required.');
    if (sessionExpiryMs(state.session) <= Date.now() + 60 * 1000) {
      await refreshAuthToken();
    }
    return state.session.access_token;
  }

  function normalizeStore(value) {
    var store = String(value || '').trim().toLowerCase();
    if (store.indexOf('fort worth') !== -1 || store === 'fort_worth') return 'fort_worth';
    if (store.indexOf('mesquite') !== -1) return 'mesquite';
    return store.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function verifiedAttributes(rep) {
    return {
      sales_rep: 'true',
      sales_rep_name: String(rep.display_name || '').trim(),
      sales_rep_monday_uid: String(rep.monday_uid || '').trim(),
      sales_rep_monday_email: normalizeEmail(rep.normalized_email || rep.email),
      sales_rep_monday_item_id: String(rep.monday_item_id || '').trim(),
      sales_rep_store: normalizeStore(rep.store_code)
    };
  }

  var clearAttributes = {
    sales_rep: '',
    sales_rep_name: '',
    sales_rep_monday_uid: '',
    sales_rep_monday_email: '',
    sales_rep_monday_item_id: '',
    sales_rep_store: ''
  };

  async function updateCart(attributes) {
    try {
      await nativeFetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    } catch (error) {
      // Database authorization never depends on this compatibility state.
    }
  }

  function setFieldValue(id, value) {
    var field = document.getElementById(id);
    if (!field) return;
    var next = String(value || '');
    var changed = field.value !== next;
    if (changed) field.value = next;
    field.setAttribute('data-sr1-verified', next);
    if (changed && field.tagName === 'SELECT') {
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function optionMatchesVerifiedRep(select, attributes) {
    if (!select || select.options.length !== 1) return false;
    var option = select.options[0];
    return String(option.value || '') === attributes.sales_rep_name &&
      String(option.getAttribute('data-monday-uid') || '') === attributes.sales_rep_monday_uid &&
      String(option.getAttribute('data-monday-email') || '') === attributes.sales_rep_monday_email &&
      String(option.getAttribute('data-monday-item-id') || '') === attributes.sales_rep_monday_item_id;
  }

  function lockCartRepSelect(select, attributes) {
    if (!select) return;
    var changed = false;
    if (!optionMatchesVerifiedRep(select, attributes)) {
      var option = document.createElement('option');
      option.value = attributes.sales_rep_name;
      option.textContent = attributes.sales_rep_name;
      option.selected = true;
      option.setAttribute('data-monday-uid', attributes.sales_rep_monday_uid);
      option.setAttribute('data-monday-email', attributes.sales_rep_monday_email);
      option.setAttribute('data-monday-item-id', attributes.sales_rep_monday_item_id);
      select.replaceChildren(option);
      changed = true;
    }
    if (select.value !== attributes.sales_rep_name) {
      select.value = attributes.sales_rep_name;
      changed = true;
    }
    select.disabled = true;
    select.setAttribute('aria-readonly', 'true');
    select.setAttribute('aria-disabled', 'true');
    select.setAttribute('data-sr1-identity-locked', 'true');
    if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function lockAssistedByRepSelect(select, attributes) {
    if (!select) return;
    var correct = select.options.length === 1 && String(select.options[0].value || '') === attributes.sales_rep_name;
    if (!correct) {
      var option = document.createElement('option');
      option.value = attributes.sales_rep_name;
      option.textContent = attributes.sales_rep_name;
      option.selected = true;
      select.replaceChildren(option);
    }
    if (select.value !== attributes.sales_rep_name) select.value = attributes.sales_rep_name;
    select.disabled = true;
    select.setAttribute('aria-readonly', 'true');
    select.setAttribute('aria-disabled', 'true');
    select.setAttribute('data-sr1-identity-locked', 'true');
    select.setAttribute('data-sr1-verified-rep', attributes.sales_rep_name);
  }

  function unlockVerifiedRepFields() {
    document.querySelectorAll('[data-sr1-identity-locked="true"]').forEach(function (field) {
      field.disabled = false;
      field.removeAttribute('aria-readonly');
      field.removeAttribute('aria-disabled');
      field.removeAttribute('data-sr1-identity-locked');
      field.removeAttribute('data-sr1-verified-rep');
    });
  }

  function enforceVerifiedRepFields() {
    if (state.phase !== 'authorized' || !state.rep) return;
    var attributes = verifiedAttributes(state.rep);
    lockCartRepSelect(document.getElementById('cart-sales-rep-name'), attributes);
    document.querySelectorAll('.cap-fp-assisted-by-rep').forEach(function (select) {
      lockAssistedByRepSelect(select, attributes);
    });
    setFieldValue('cart-sales-rep-monday-uid', attributes.sales_rep_monday_uid);
    setFieldValue('cart-sales-rep-monday-email', attributes.sales_rep_monday_email);
    setFieldValue('cart-sales-rep-monday-item-id', attributes.sales_rep_monday_item_id);
    setFieldValue('cart-sales-rep-store', attributes.sales_rep_store);
  }

  function ensureSalesRepCartUiAvailable() {
    if (state.phase !== 'authorized' || window.location.pathname !== '/cart') return;
    var cartRoot = document.querySelector('cart-items');
    if (!cartRoot) return;
    var reloadKey = 'cap_sr1_cart_ui_reload_v1';
    if (document.querySelector('.cart-rep-fields')) {
      try { window.sessionStorage.removeItem(reloadKey); } catch (error) {}
      return;
    }
    try {
      if (window.sessionStorage.getItem(reloadKey) === '1') return;
      window.sessionStorage.setItem(reloadKey, '1');
    } catch (error) {
      return;
    }
    window.location.reload();
  }

  function scheduleRevalidation() {
    window.clearTimeout(state.timer);
    if (state.phase !== 'authorized') return;
    var delay = Math.max(15 * 1000, Math.min(120 * 1000, state.freshUntil - Date.now() - 20 * 1000));
    state.timer = window.setTimeout(function () { refreshAuthorization(true); }, delay);
  }

  async function refreshAuthorization(force) {
    if (!force && state.phase === 'authorized' && state.freshUntil > Date.now() + 20 * 1000) {
      return getPublicState();
    }
    if (state.authPromise) return state.authPromise;

    state.authPromise = (async function () {
      var token = await ensureLiveToken();
      var response = await nativeFetch(supabaseUrl + '/functions/v1/sr1-auth-refresh', {
        method: 'POST',
        headers: {
          apikey: publishableKey,
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: '{}'
      });
      var payload = await safeJson(response);
      if (!response.ok || payload.authorized !== true || !payload.rep) {
        state.phase = response.status === 503 ? 'unavailable' : 'unauthorized';
        state.rep = null;
        state.freshUntil = 0;
        await updateCart(clearAttributes);
        emit();
        throw new Error(response.status === 503
          ? 'Secure verification is temporarily unavailable. Please try again.'
          : 'This account is not authorized for Sales Rep access.');
      }

      var email = normalizeEmail(payload.rep.normalized_email || payload.rep.email);
      if (!email || !payload.rep.monday_item_id) throw new Error('Verified profile is incomplete.');
      state.rep = Object.assign({}, payload.rep, { normalized_email: email, email: email });
      state.freshUntil = Date.parse(payload.fresh_until || '') || 0;
      if (state.freshUntil <= Date.now()) throw new Error('Verified access is stale.');
      state.phase = 'authorized';
      await updateCart(verifiedAttributes(state.rep));
      enforceVerifiedRepFields();
      scheduleRevalidation();
      emit();
      return getPublicState();
    })().catch(async function (error) {
      if (state.phase === 'checking') {
        state.phase = 'unauthorized';
        await updateCart(clearAttributes);
        emit();
      }
      throw error;
    }).finally(function () {
      state.authPromise = null;
    });
    return state.authPromise;
  }

  async function startOtp(email) {
    var normalized = normalizeEmail(email);
    var response = await nativeFetch(supabaseUrl + '/functions/v1/sr1-auth-start', {
      method: 'POST',
      headers: { apikey: publishableKey, 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: normalized })
    });
    var payload = await safeJson(response);
    if (!response.ok || payload.accepted !== true) {
      var message = typeof payload.message === 'string' ? payload.message.trim() : '';
      throw new Error(message || 'We could not start secure sign-in. Please try again.');
    }
    return { accepted: true, email: normalized };
  }

  async function verifyOtp(email, token) {
    var normalized = normalizeEmail(email);
    var digits = String(token || '').replace(/\D/g, '');
    var response = await nativeFetch(supabaseUrl + '/auth/v1/verify', {
      method: 'POST',
      headers: {
        apikey: publishableKey,
        Authorization: 'Bearer ' + publishableKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: normalized, token: digits, type: 'email' })
    });
    var payload = await safeJson(response);
    if (!response.ok || !payload.access_token || !payload.refresh_token) {
      throw new Error('That code is incorrect, expired, or already used.');
    }
    saveSession(payload);
    state.phase = 'checking';
    emit();
    try {
      return await refreshAuthorization(true);
    } catch (error) {
      await logout();
      throw error;
    }
  }

  async function logout() {
    window.clearTimeout(state.timer);
    var token = state.session && state.session.access_token;
    if (token) {
      try {
        await nativeFetch(supabaseUrl + '/auth/v1/logout?scope=local', {
          method: 'POST',
          headers: { apikey: publishableKey, Authorization: 'Bearer ' + token }
        });
      } catch (error) {
        // Local cleanup still completes.
      }
    }
    saveSession(null);
    state.rep = null;
    state.freshUntil = 0;
    state.phase = 'unauthorized';
    await updateCart(clearAttributes);
    emit();
    return getPublicState();
  }

  function deniedResponse() {
    return Promise.resolve(new Response(JSON.stringify({
      code: 'SR1_AUTH_REQUIRED',
      message: 'Secure Sales Rep authorization is required.'
    }), {
      status: 403,
      headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' }
    }));
  }

  async function protectedCartUpdate(input, init, url) {
    var request = input instanceof Request
      ? new Request(input, init)
      : new Request(url.toString(), init);
    if (request.method.toUpperCase() !== 'POST') return nativeFetch(request);
    try {
      var payload = await request.clone().json();
      payload = payload && typeof payload === 'object' ? payload : {};
      payload.attributes = Object.assign({}, payload.attributes || {}, verifiedAttributes(state.rep));
      var headers = new Headers(request.headers);
      headers.set('Content-Type', 'application/json');
      var protectedRequest = new Request(request, {
        headers: headers,
        body: JSON.stringify(payload)
      });
      var response = await nativeFetch(protectedRequest);
      window.setTimeout(enforceVerifiedRepFields, 0);
      return response;
    } catch (error) {
      var fallbackResponse = await nativeFetch(request);
      window.setTimeout(enforceVerifiedRepFields, 0);
      return fallbackResponse;
    }
  }

  window.fetch = async function sr1ProtectedFetch(input, init) {
    var rawUrl = input instanceof Request ? input.url : String(input);
    var url;
    try { url = new URL(rawUrl, window.location.origin); } catch (error) { return nativeFetch(input, init); }

    var isSameOrigin = url.origin === window.location.origin;
    if (isSameOrigin && url.pathname === '/cart/update.js' && state.phase === 'authorized' && state.rep) {
      return protectedCartUpdate(input, init, url);
    }

    if (!supabaseUrl || url.origin !== new URL(supabaseUrl).origin) return nativeFetch(input, init);

    var parts = url.pathname.split('/').filter(Boolean);
    if (parts[0] === 'rest' && parts[1] === 'v1' && sensitiveReadModels.has(parts[2] || '')) {
      return deniedResponse();
    }
    if (parts[0] !== 'rest' || parts[1] !== 'v1' || parts[2] !== 'rpc' || !parts[3]) {
      return nativeFetch(input, init);
    }

    var rpcName = decodeURIComponent(parts[3]);
    var targetName = '';
    var needsRepAuthorization = false;
    if (repRpcMap[rpcName]) {
      targetName = repRpcMap[rpcName];
      needsRepAuthorization = true;
    } else if (dualRpcMap[rpcName]) {
      var alreadyAuthorized = state.phase === 'authorized' && state.freshUntil > Date.now() + 3 * 1000;
      if (!alreadyAuthorized && state.session) {
        try {
          await refreshAuthorization(false);
          alreadyAuthorized = state.phase === 'authorized' && state.freshUntil > Date.now() + 3 * 1000;
        } catch (error) {
          alreadyAuthorized = false;
        }
      }
      targetName = alreadyAuthorized ? dualRpcMap[rpcName].rep : dualRpcMap[rpcName].public;
      needsRepAuthorization = alreadyAuthorized;
    } else {
      return nativeFetch(input, init);
    }

    var token = '';
    if (needsRepAuthorization) {
      try {
        await refreshAuthorization(false);
        token = await ensureLiveToken();
      } catch (error) {
        return deniedResponse();
      }
    } else if (repRpcMap[rpcName]) {
      return deniedResponse();
    }

    parts[3] = encodeURIComponent(targetName);
    url.pathname = '/' + parts.join('/');
    var request = input instanceof Request
      ? new Request(url.toString(), input)
      : new Request(url.toString(), init);
    if (input instanceof Request && init) request = new Request(request, init);
    var headers = new Headers(request.headers);
    headers.set('apikey', publishableKey);
    if (token) headers.set('Authorization', 'Bearer ' + token);
    return nativeFetch(new Request(request, { headers: headers }));
  };


  var customerProfileActions = {
    search_customers: true,
    get_customer_profile: true,
    get_tax_exemptions: true,
    create_customer: true,
    update_sms_marketing: true,
    update_email_marketing: true,
    update_customer_profile: true,
    update_tax_status: true
  };

  var quoteWorkflowActions = {
    create: 'create_quote',
    update: 'update_quote',
    status: 'quote_status',
    retry: 'retry_quote'
  };

  async function repToolsProxyFetch(action, payload) {
    await refreshAuthorization(false);
    var token = await ensureLiveToken();
    var body = Object.assign(
      {},
      payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {},
      { action: action, access_token: token }
    );
    return nativeFetch('/apps/callahan-rep-tools', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function batch05DecisionSupportFetch(payload) {
    return repToolsProxyFetch('get_batch05_decision_support', payload);
  }

  function customerProfileFetch(action, payload) {
    action = String(action || '').trim();
    if (!customerProfileActions[action]) throw new Error('Unsupported customer action.');
    return repToolsProxyFetch(action, payload);
  }

  function quoteWorkflowFetch(action, payload) {
    action = String(action || '').trim().toLowerCase();
    var proxyAction = quoteWorkflowActions[action];
    if (!proxyAction) throw new Error('Unsupported quote action.');
    return repToolsProxyFetch(proxyAction, payload);
  }

  state.session = loadSession();

  function isLockedIdentityField(target) {
    return Boolean(target && target.matches && target.matches(
      '#cart-sales-rep-name[data-sr1-identity-locked="true"], .cap-fp-assisted-by-rep[data-sr1-identity-locked="true"]'
    ));
  }

  ['change', 'input', 'pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (state.phase !== 'authorized' || !event.isTrusted || !isLockedIdentityField(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      enforceVerifiedRepFields();
    }, true);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (state.phase !== 'authorized' || !target || !target.matches) return;
    if (target.matches('#cart-sales-rep-monday-uid, #cart-sales-rep-monday-email, #cart-sales-rep-monday-item-id')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      enforceVerifiedRepFields();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    enforceVerifiedRepFields();
    ensureSalesRepCartUiAvailable();
    var observer = new MutationObserver(function (mutations) {
      if (state.phase !== 'authorized') return;
      var shouldEnforce = mutations.some(function (mutation) {
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });
      if (shouldEnforce) enforceVerifiedRepFields();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });

  var ready = (async function bootstrap() {
    if (!supabaseUrl || !publishableKey) {
      state.phase = 'unavailable';
      emit();
      return getPublicState();
    }
    if (!state.session) {
      state.phase = 'unauthorized';
      await updateCart(clearAttributes);
      emit();
      return getPublicState();
    }
    try {
      return await refreshAuthorization(true);
    } catch (error) {
      return getPublicState();
    }
  })();

  window.CAP_SR1 = Object.freeze({
    ready: ready,
    getState: getPublicState,
    startOtp: startOtp,
    verifyOtp: verifyOtp,
    refresh: function () { return refreshAuthorization(true); },
    customerProfileFetch: customerProfileFetch,
    quoteWorkflowFetch: quoteWorkflowFetch,
    decisionSupportFetch: batch05DecisionSupportFetch,
    logout: logout
  });
})(window, document);
